<template>
  <v-container
    fluid
    class="pt-2"
    :class="{ 'px-2': $vuetify.breakpoint.width <= 1600, 'px-0': $vuetify.breakpoint.width > 1600 }"
  >
    <v-layout align-content-start>
      <v-flex xs8 xl9>
        <v-tabs class="mr-1" v-if="showDetails" icons-and-text>
          <v-tabs-slider color="accent"></v-tabs-slider>
          <v-tab v-if="showFundedReferrals"><v-icon class="mr-1">fad fa-comments</v-icon> Funded Enquiries</v-tab>
          <v-tab>Comments <v-icon class="mr-1">fad fa-comments</v-icon></v-tab>
          <v-tab>Documents <v-icon class="mr-1">fad fa-file</v-icon></v-tab>
          <v-tab-item v-if="showFundedReferrals">
            <v-card class="customer-summary-list" light flat>
              <template v-for="(enquiry, idx) in ReferralEnquiries">
                <referral-enquiry :enquiry="enquiry" :key="`enquiry-${idx}`" />
                <v-divider v-if="idx < ReferralEnquiries.length - 1" :key="`divider-${idx}`"></v-divider>
              </template>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="customer-summary-list" light flat>
              <v-progress-circular
                size="20"
                :width="3"
                color="accent"
                indeterminate
                class="ml-2"
                v-if="LoadingComments"
              ></v-progress-circular>
              <div></div>
              <comment-form :referral="referral"></comment-form>
              <comment-list :customer="referral"></comment-list>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="customer-summary-list" light flat>
              <document-list
                :documents="ReferralDocuments"
                :customer="null"
                :referral="referral"
                v-if="
                  UserHasRole('Platform') ||
                    UserHasRole('Call Centre') ||
                    UserHasRole('Partner') ||
                    (showDetails && UserHasRole('Provider'))
                "
              ></document-list>
            </v-card>
          </v-tab-item>
        </v-tabs>
        <v-card class="customer-summary-container mb-2 mr-1" flat v-else>
          <v-subheader class="title mt-3">Content Hidden</v-subheader>
          <v-card-text>Review answers and accept enquiry to view more details</v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs4 xl3>
        <v-card class="customer-summary-container mb-2 ml-1" flat>
          <v-subheader class="title">
            Business Details
          </v-subheader>
          <v-card flat class="pa-2">
            <referral-info :referral="referral"></referral-info>
          </v-card>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import DocumentList from '../Customers/OverviewDrawer/Documents/DocumentList';
import CommentForm from './Widgets/CommentForm';
import CommentList from './Widgets/CommentList';
import ReferralInfo from './ReferralInfo';
import ReferralEnquiry from '@/components/Platform/Referrals/ReferralEnquiry';

export default {
  components: {
    ReferralEnquiry,
    CommentForm,
    CommentList,
    DocumentList,
    ReferralInfo
  },
  name: 'referral-summary',
  props: ['referral'],
  data: () => ({}),
  methods: {},
  computed: {
    ...mapGetters([
      'FunderEnquiries',
      'LoadingComments',
      'PlatformUser',
      'ReferralDocuments',
      'ReferralEnquiries',
      'UserHasRole',
      'AccountId'
    ]),
    showDetails() {
      if (this.PlatformUser() || this.UserHasRole('Call Centre')) {
        return true;
      }
      return this.referral.referrer.account_id === this.AccountId;
    },
    showFundedReferrals() {
      return this.showDetails && this.ReferralEnquiries.length > 0;
    }
  }
};
</script>

<style lang="scss" scoped>
.customer-summary-container {
  height: calc(100vh - 237px);
  max-height: calc(100vh - 237px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 0;
}

.customer-summary-list {
  height: calc(100vh - 285px);
  max-height: calc(100vh - 285px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
